import React from "react";
import { withTranslation } from "react-i18next";
import { Modal, } from "antd";
import { PlusOutlined } from '@ant-design/icons';
import styled from "styled-components";
import { connect } from "react-redux";

import Text from "components/Text";
import Title from "components/Title";
import ImageError from "screens/Home/ImageError";

const StyledMount = styled.div`
  display: flex;
  flex-direction: column;
  background: ${props => props.background ? props.background : 'black'};
  width: 110px;
  height: 110px;
  padding: 10px;
  margin: 10px;
  box-shadow: ${props => props.shadow ? '0 0 10px grey' : 'none'};
  cursor: pointer;
`;

/**
 * UserMountsModal
 * @param {*} props 
 * @returns 
 */
const UserMountsModal = (props) => {

  const handleOnSelectMount = (mount) => {
    props.setSelectedMount(mount);
    props.onOk();
  }

  // const setOrginalPicture = (e, original) => {
  //   e.target.src = `${process.env.REACT_APP_S3_FILES_URL}${original}`
  // }

  return (
    <Modal
      visible={props.visible}
      onOk={props.onOk}
      onCancel={props.onCancel}
      footer={null}
      width={'96%'}
      style={{ top: 10, maxWidth: 570 }}
    >
      <Title style={{ marginBottom: 20, marginTop: -4 }} size={18}>Vos montages</Title>
      <Text style={{ marginBottom: 10, }} size={14} color="grey">Sélectionnez le montage que vous souhaitez imprimer, ou créez-en un nouveau</Text>

      {
        props.totalGeneratedEffects >= props.auth.user.max_photoshop_effects ? (
          <Text style={{ marginBottom: 20, }} size={14} color="grey">Vous avez dépassé le nombre d'effets pouvant être créés. Contactez nous pour en créer de nouveaux</Text>
        ) : (
          <Text style={{ marginBottom: 20, }} size={14} color="grey">Vous pouvez créer jusqu'à {props.auth.user.max_photoshop_effects - props.totalGeneratedEffects} effets supplémentaires</Text>
        )
      }

      <div style={{ width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'flex-start', alignItems: 'center' }}>
        {
          props.totalGeneratedEffects < props.auth.user.max_photoshop_effects && (
            <StyledMount 
              background={props.ui.theme.buttonColor}
              onClick={() => { props.setDisplayCreateEffectModal(true); props.onOk()}} 
              style={{ cursor: 'pointer', border: `1px solid ${props.ui.theme.buttonColor}` }}
            >
              <PlusOutlined style={{ color: 'white', fontSize: 25, marginTop: 20  }} />
              <Text size={14} color="white" align="center" style={{ marginTop: 5 }}>Nouveau montage</Text>
            </StyledMount>
          )
        }

        {
          props.mountsHistory.map((mount) => (
            <StyledMount
              key={`mount-selection-${mount._id}`}
              onClick={() => handleOnSelectMount(mount)}
            >
              <ImageError
                thumbnail={`${process.env.REACT_APP_S3_FILES_URL}thumbnails/${mount.output}`}
                output={`${process.env.REACT_APP_S3_FILES_URL}${mount.output}`}
                width={90} 
                alt={mount.name}
              />
            </StyledMount>
          ))
        }
      </div>
    </Modal>
  )
}

const stateToProps = state => ({
  ui: state.ui
})

export default connect(stateToProps)(withTranslation()(UserMountsModal));